var axios = require('axios')

// get list user orders
axios.getUserOrderReport = function (success, callBackError) {
  this.get(process.env.prefix_report + '/users')
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getHitRateReport = function (params, success, callBackError) {
  this.get(process.env.prefix_report + '/orders/hit-rate' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getTransactionSaleReport = function (params, success, callBackError) {
  this.get(process.env.prefix_report + '/orders/hourly-sale' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getTransactionSaleReportV2 = function (params, success, callBackError) {
  this.get(process.env.prefix_hourly_sales_report + '/sales/hourly' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getTransactionCountReport = function (params, success, callBackError) {
  this.get(process.env.prefix_report + '/orders/hourly-count' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateReadyForUser = function (params, success, callBackError) {
  this.put(process.env.prefix_report + '/users/update-ready', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getNotReadyUser = function (success, callBackError) {
  this.get(process.env.prefix_report + '/users/list-not-ready')
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getLatestStoreStatus = function (params, success, callBackError) {
  this.get(process.env.prefix_report + '/store/latest' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getStoreStatus = function (params, success, callBackError) {
  this.get(process.env.prefix_report + '/store' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getOrderReport = function (params, success, callBackError) {
  this.get(process.env.prefix_report + '/orders/report-order?' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getNewSalesReportData = function (params, success, callBackError) {
  this.get(process.env.prefix_report + '/orders/new-sale-report?' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getOrderExportCSV = function (params, success, callBackError) {
  this.get(process.env.prefix_report + '/orders/report-csv?' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getOutletGroupList = function (params, success, callBackError) {
  this.post(process.env.prefix_report + '/orders/outlets', params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getOutletsOrder = function (params, success, callBackError) {
  this.post(process.env.prefix_report + '/orders/outlets', params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getCouponRedemptionReportDetails = function (params, success, callBackError) {
  axios({
    method: 'get',
    url: process.env.host + '/' + process.env.version + '/' + process.env.prefix_report + '/coupon/coupon-reports?' + params
  }).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.exportCouponRedemptionReportDetails = function (params, success, callBackError) {
  axios({
    method: 'get',
    url: process.env.host + '/' + process.env.version + '/' + process.env.prefix_report + '/coupon/coupon-file?' + params,
    responseType: 'blob'
  }).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getNewSalesOrderReportData = function (params, success, callBackError) {
  this.get(process.env.prefix_report + '/orders/datadog-metric-sale-report?' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getNewSalesOrderReportDataV2 = function (params, success, callBackError) {
  axios({
    method: 'get',
    url: process.env.host + '/' + process.env.version + '/' + process.env.prefix_report + '/orders/datadog-metric-sale-report?' + params
  }).then(function (response) {
    success(response)
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/api/Report.js